export default __webpack_public_path__ + "static/media/github.bf723dcd.svg";